export default class ApiResponseError extends Error{
    constructor(response){
        super();
        this.response = response;
        this.message = this.getMessage(response);
        this.stack = (new Error(this.message)).stack;
        this.name = this.constructor.name;
    }
    getMessage = (response) => {
        let message = 'Error desconocido';
        switch(response.status){
            case 400:
                switch(response.data.code){
                    case 2: message = 'Error, uno o más parámetros son inválidos.'; break;
                    case 4: message = 'Error, token inválido.'; break;
                }
            break;
            case 401:
                switch(response.data.code){
                    case 5: message = 'Error de Autenticación'; break;
                    case 35: message = 'Cliente se encuentra con un pago pendiente'; break;
                }
            break;
            case 403:
                switch(response.data.code){
                    case 3: message = 'Autenticación inválida.'; break;
                    case 5: message = 'Error, ya existe un registro con el slug asociado.'; break;
                    case 7: message = 'Error, registro eliminado.'; break;
                    case 9: message = 'Error, transacciones externas no autorizadas.'; break;
                    case 10: message = 'Error, la cuenta ya existe con los datos proporcionados.'; break;
                    case 11: message = 'Error, ya existe el nombre de usuario proporcionado.'; break;
                    case 14: message = 'Error, posee registros asociados.'; break;
                    case 15: message = 'Cotización ya confirmada'; break;
                    case 16: message = 'Email ya verificado'; break;
                    case 17: message = 'Email no se encuentra verificado'; break;
                    case 18: message = 'Ha superado la cantidad de solicitudes para este recurso.'; break;
                    case 19: message = 'Su empresa ha sido desactivada. Contactese con el área de Soporte.'; break;

                    case 1001: message = 'Error de permisos: acción no permitida.'; break;
                    case 1002: message = 'Error de permisos: sin permisos para ejecutar la acción requerida.'; break;
                    case 1003: message = 'Error de permisos: rol inválido.'; break;
                    case 1004: message = 'Error de permisos: usted no es dueño del recurso que intenta utilizar.'; break;
                }
            break;
            case 404:
                switch(response.data.code){
                    case 5: message = 'Error, registro no encontrado.'; break;
                }
            break;
            case 409:
                switch(response.data.code){
                    case 13: message = 'Error, ya existe un registro con los datos proporcionados.'; break;
                }
            break;
        }
        return message;
    }
    getFields = () => {
        let fields = {};
        if (this.response.data && this.response.data.details){
            fields = this.response.data.details;
        }
        return fields;
    }
}




// WEBPACK FOOTER //
// ./src/Services/ApiResponseError.js